// tslint:disable:max-line-length

import React from 'react';

export const ArrowDown = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 16 16" {...props}>
      <polygon points="0.5,8 8,15.5 15.5,8 14.1,6.6 9,11.8 9,0.5 7,0.5 7,11.8 1.9,6.6" />
    </svg>
  );
};
